import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { removeScreendFund, removeSearchTicker, loadFundDetailsPortfolio, toggleFundSelection } from '../../../actions'
import './TickerSelection.css'
import i18n from '../../../i18n.js'
import { clearTickers } from '../../../actions'

const TickerSelection = ({ resultsScreen }) => {
  const data = useSelector(state => state.fundData.data)
  const screenedFunds = useSelector(state => state.params.screenedFunds)
  const showFundSelection = useSelector(state => state.params.showFundSelection)
  const dispatch = useDispatch()
  const [count, setCount] = useState(resultsScreen ? screenedFunds.length : 0)
  const styleCount = screenedFunds.length > 0 ? true : false

  const handleDeleteTicker = externalID => {
    if (resultsScreen && screenedFunds.length === 1) {
      dispatch(clearTickers())
    } else {
      dispatch(removeScreendFund(externalID))
      dispatch(removeSearchTicker(externalID))
    }
  }

  // Submit the analysis
  const handleAnalyze = () => {
    dispatch(loadFundDetailsPortfolio(true, null))
    setCount(screenedFunds.length)
    if (resultsScreen) {
      dispatch(toggleFundSelection())
    }
  }

  const TickerList = () => {
    return (
      <div className="screenedList col-md-10 col-sm-12">
        {screenedFunds.slice(0, 6).map(fund => (
          <div key={fund.externalID} className="screenedFund">
            {fund.name} {fund.ticker ? `(${fund.ticker})` : ''}
            <div
              onClick={() => handleDeleteTicker(fund.externalID)}
              style={{ float: 'right', cursor: 'pointer', padding: '0 10px', fontWeight: 600 }}
            >
              x
            </div>
          </div>
        ))}
        {(screenedFunds?.length > 6 && (data?.length === 0 || !data) ) && <span> Maximum 6 Tickers </span> }
      </div>
    )
  }


  const ReAnalyzeButton = () => {
    if (count === screenedFunds.length) {
      return (
        <div className={`${'analyzeButton'} col-md-2 col-sm-12`}>
          <div>
            <button className='buttonRefresh' onClick={() => dispatch(clearTickers())}>
              {i18n.t('clear all')}
            </button>
          </div>
        </div>
      )
    }
    return (
      <>
        {screenedFunds.length > 0 && (
          <div className={`${'analyzeButton'} col-md-2 col-sm-12`}>
            <div>
              <button className='buttonRefresh' disabled={screenedFunds.length === 0} onClick={handleAnalyze}>
                {i18n.t('refresh-btn')}
              </button>
            </div>
          </div>
        )}
      </>
    )
  }

  if (resultsScreen && showFundSelection) {
    return null
  }

  if (resultsScreen) {
    return (
      <div className="tickerSelection row" style={{ marginBottom: 10, width: '98%' }}>
        <TickerList />
        <ReAnalyzeButton />
      </div>
    )
  }

  return (
    <div className="tickerSelection">
      <div className={`row`} style={{ paddingTop: styleCount ? '35px' : '0px', paddingBottom: styleCount ? '15px' : '0px' }}>
        <TickerList />
        {screenedFunds.length > 0 && (
          <div className={`${'analyzeButton'} col-md-2 col-sm-12`}>
            <div>
              <button className='button' disabled={screenedFunds.length === 0} onClick={handleAnalyze}>
                {i18n.t('analyze-funds')}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default TickerSelection
